import { Navigate, Outlet, useLocation } from "react-router-dom";

import ForceChangePasswordModal from "./ForceChangePasswordModal";
import { selectIsAuthenticated, useAuthStore } from "./store";

/** 미인증 시 /login 으로 리다이렉트하고, 원래 가려던 경로를 state 로 보존.
 *
 * M12 — 인증되었지만 ``user.must_change_password === true`` 인 경우 모든 페이지
 * 위에 강제 비밀번호 변경 모달을 띄운다. (모달 자체에서 닫기 차단.)
 */
export default function ProtectedRoute() {
  const isAuthed = useAuthStore(selectIsAuthenticated);
  const mustChangePw = useAuthStore((s) => !!s.user?.must_change_password);
  const location = useLocation();

  if (!isAuthed) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return (
    <>
      <Outlet />
      {mustChangePw ? <ForceChangePasswordModal /> : null}
    </>
  );
}
